import { useEffect, useMemo } from 'react';
import { t } from 'i18next';
import { useInicisPayment } from './hooks/useInicisPayment';
import { ReactComponent as BlueArrowRightIcon } from '../../icons/blue.arrow.right.svg';

const InicisPaymentLaunchPage = () => {
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const amount = searchParams.get('amount') ?? '';
  const productName = searchParams.get('productName') ?? '';
  const productId = searchParams.get('productId') ?? '';

  const { handleCreateOrder } = useInicisPayment({
    amount,
    productName,
    productId
  });

  useEffect(() => {
    // 파라미터가 유효하면 즉시 결제 생성 및 결제요청(이니시스 form submit) 수행
    if (productId && amount && productName) {
      void handleCreateOrder();
    }
  }, [amount, productId, productName, handleCreateOrder]);

  return (
    <div className="min-h-screen flex flex-col gap-[38px] items-center justify-center">
      <BlueArrowRightIcon width={65} height={65} />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[28px] text-center">
        {t('InicisPaymentLaunch.moveToPayment')}
      </p>
    </div>
  );
};

export default InicisPaymentLaunchPage;
